import { formatHandle } from './callFormatUtils';

/** Coerce navigation state or query `callDurationSec` to a non-negative integer second count. */
export const parseCallDurationSec = (fromState, fromQuery) => {
  const raw =
    fromState !== undefined && fromState !== null && fromState !== '' ? fromState : fromQuery;
  if (raw === undefined || raw === null || raw === '') return 0;
  const n = Number(raw);
  if (!Number.isFinite(n) || n < 0) return 0;
  return Math.floor(n);
};

export const parseCallSummaryBooleanFlag = (value) => {
  if (value === true || value === '1' || value === 1 || value === 'true') return true;
  if (value === false || value === '0' || value === 0 || value === 'false') return false;
  return undefined;
};

/** Human-readable duration for post-call summary (not MM:SS in-call timer). */
export const formatCallDurationSummary = (durationSec) => {
  const sec = Number(durationSec || 0);
  if (!Number.isFinite(sec) || sec <= 0) return '0 sec';
  if (sec < 1) return 'Under 1 sec';

  const totalSeconds = Math.floor(sec);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    return `${hours}h ${minutes}m ${seconds}s`;
  }
  if (minutes > 0) {
    return `${minutes}m ${seconds}s`;
  }
  return `${seconds} sec`;
};

/** Display name for summary headers; uses {@link formatHandle} with "Unknown" for empty handles. */
export const formatCallSummaryDisplayName = (rawName) => {
  const handle = formatHandle(rawName);
  if (handle === '@unknown') return 'Unknown';
  return handle;
};

export const humanizeCallEndedReason = (raw, hangupParty, opponentDisplayName, isCreatorView) => {
  if (!raw) return null;
  const code = String(raw);
  switch (code) {
    case 'invite_timeout':
      return 'Call timed out';
    case 'ice_failed':
      if (!isCreatorView && hangupParty === 'remote') return 'Creator ended the call.';
      return 'Connection failed';
    case 'no_user_media':
      return 'Microphone/camera unavailable';
    case 'user_hangup':
      if (hangupParty === 'remote') {
        if (!isCreatorView) return 'Creator ended the call.';
        return `Ended by ${opponentDisplayName}`;
      }
      return 'Ended by you';
    case 'insufficient_credits':
      if (isCreatorView) return 'Subscriber ran out of credits';
      return 'Ran out of credits';
    default:
      return code;
  }
};
